import { render, staticRenderFns } from "./ReceiptDetail.vue?vue&type=template&id=1a20ad3f&"
import script from "./ReceiptDetail.vue?vue&type=script&lang=js&"
export * from "./ReceiptDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports